import { SelectColor } from 'components/colors/component'
import * as React from 'react'
import { Input, Label } from 'reactstrap'
import { getConfiguration } from '../../utils'

interface ResultsSettingsProps {
  data: any
  name?: string
  onChange: (field: string, value: any) => void
}

export class ResultsSettings extends React.Component<ResultsSettingsProps> {
  public render() {
    return (
      <div>
        <div className="widget-settings-section">
          <h4>Results Display</h4>
          
          <div className="setting-item">
            <Label>Show Percentage</Label>
            <Input
              type="select"
              value={getConfiguration(this.props.data, 'survey_results_show_percentage', 'true')}
              onChange={(e) => this.props.onChange('survey_results_show_percentage', e.target.value)}
            >
              <option value="true">Show</option>
              <option value="false">Hide</option>
            </Input>
          </div>

          <div className="setting-item">
            <Label>Show Vote Count</Label>
            <Input
              type="select"
              value={getConfiguration(this.props.data, 'survey_results_show_vote_count', 'true')}
              onChange={(e) => this.props.onChange('survey_results_show_vote_count', e.target.value)}
            >
              <option value="true">Show</option>
              <option value="false">Hide</option>
            </Input>
          </div>

          <div className="setting-item">
            <Label>Show Progress Bar</Label>
            <Input
              type="select"
              value={getConfiguration(this.props.data, 'survey_results_show_progress_bar', 'true')}
              onChange={(e) => this.props.onChange('survey_results_show_progress_bar', e.target.value)}
            >
              <option value="true">Show</option>
              <option value="false">Hide</option>
            </Input>
          </div>

        </div>

        <div className="widget-settings-section">
          <h4>Statistics Section</h4>
          
          <div className="setting-item">
            <Label>Show Quick Stats</Label>
            <Input
              type="select"
              value={getConfiguration(this.props.data, 'survey_results_show_stats', 'true')}
              onChange={(e) => this.props.onChange('survey_results_show_stats', e.target.value)}
            >
              <option value="true">Show</option>
              <option value="false">Hide</option>
            </Input>
          </div>

          <div className="setting-item">
            <Label>Show Survey Info</Label>
            <Input
              type="select"
              value={getConfiguration(this.props.data, 'survey_results_show_survey_info', 'true')}
              onChange={(e) => this.props.onChange('survey_results_show_survey_info', e.target.value)}
            >
              <option value="true">Show</option>
              <option value="false">Hide</option>
            </Input>
            <small className="form-text text-muted">
              Shows total responses, survey type, and creation date
            </small>
          </div>
        </div>

        <div className="widget-settings-section">
          <h4>Results Colors</h4>
          
          <div className="setting-item">
            <Label>Top Choice Accent Color</Label>
            <SelectColor
              className="primary"
              selectColor={(color: string) => this.props.onChange('survey_results_top_choice_color', color)}
              color={getConfiguration(this.props.data, 'survey_results_top_choice_color', '#28a745')}
            />
            <small className="form-text text-muted">
              Color used to highlight the top performing option
            </small>
          </div>

          <div className="setting-item">
            <Label>Statistics Card Background</Label>
            <SelectColor
              className="secondary"
              selectColor={(color: string) => this.props.onChange('survey_results_stats_background', color)}
              color={getConfiguration(this.props.data, 'survey_results_stats_background', '#f8f9fa')}
            />
          </div>
        </div>

        <div className="widget-settings-section">
          <h4>Advanced Options</h4>
          
          <div className="setting-item">
            <Label>Decimal Places for Percentages</Label>
            <Input
              type="select"
              value={getConfiguration(this.props.data, 'survey_results_decimal_places', '1')}
              onChange={(e) => this.props.onChange('survey_results_decimal_places', e.target.value)}
            >
              <option value="0">0 (65%)</option>
              <option value="1">1 (65.4%)</option>
              <option value="2">2 (65.43%)</option>
            </Input>
          </div>

        </div>
      </div>
    )
  }
}